import { useEffect, useState } from 'react'

import { useFormik } from 'formik'
import { _object } from 'utils/interfaces'

import { Button, InputField } from '../form-inputs'
import { Country, State, City } from 'country-state-city'
import { v4 as uuid } from 'uuid'
import { customersService } from 'services/customers.services'

const EditCustomerModal = (props: _object) => {
  const [customer, setCustomer] = useState<_object>({})
  const [loading, setLoading] = useState(false)
  const [countries, setCountries] = useState<_object>([])
  const [states, setStates] = useState<_object>([])
  const [cities, setCities] = useState<_object>([])

  const [selectedCountry, setSelectedCountry] = useState('')
  const [selectedState, setSelectedState] = useState('')
  const [selectedCity, setSelectedCity] = useState('')

  useEffect(() => {
    setCountries(Country.getAllCountries())
  }, [])

  useEffect(() => {
    if (selectedCountry) {
      setStates(State.getStatesOfCountry(selectedCountry))
      setCities([])
      setSelectedState('')
      setSelectedCity('')
    }
  }, [selectedCountry])

  useEffect(() => {
    if (selectedState) {
      setCities(City.getCitiesOfState(selectedCountry, selectedState))
      setSelectedCity('')
    }
  }, [selectedState])

  useEffect(() => {
    customersService.getCustomerDetails(props?.id).then((results: _object) => {
      setCustomer(results)
    })
  }, [props?.id])

  // const validationSchema = Yup.object({
  //   title: Yup.string().label('Title').required(),
  //   description: Yup.string().label('description').required()
  // })
  const formik: any = useFormik({
    initialValues: {
      first_name: customer?.first_name || '',
      last_name: customer?.last_name || '',
      gender: customer.gender || '',
      status: customer.status || '',
      role: customer.role || '',
      address1: '',
      address2: '',
      landmark: '',
      postcode: '',
      country: '',
      state: customer.state || '',
      city: customer.city || ''
    },
    enableReinitialize: true,
    // validationSchema,
    onSubmit: (values) => {
      customersService.UpdateCustomer(props.id, values).then((results: _object) => {
        if (results.error === false) {
          window.location.reload()
        }
      })
      setLoading(true)
    }
  })

  return (
    <div
      id={`customer-modal${props?.id}`}
      tabIndex={-1}
      aria-hidden="true"
      className="fixed top-0 right-0 left-0 z-50 flex hidden h-[calc(100%-1rem)] max-h-full w-full items-center justify-center overflow-x-hidden overflow-y-auto md:inset-0"
    >
      <div className="fixed inset-0 bg-black/50"></div>

      {/* Modal Content */}
      <div className="relative z-10 max-h-full w-full max-w-2xl p-4">
        <div className="relative rounded-lg border border-gray-200 bg-white shadow-sm">
          <div className="flex items-center justify-between rounded-t border-b border-gray-200 p-3 px-5">
            <h3 className="text-lg font-semibold">Edit Customer</h3>
            <button
              type="button"
              className="ms-auto inline-flex h-8 w-8 items-center justify-center rounded-lg bg-transparent text-sm text-gray-400"
              data-modal-hide={`customer-modal${props?.id}`}
            >
              <svg
                className="h-3 w-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
          </div>{' '}
          <form onSubmit={formik.handleSubmit} className="p-5">
            <InputField
              label="first Name"
              name="first_name"
              type="text"
              placeholder="First Name"
              onChange={formik.handleChange}
              value={formik.values.first_name}
              onBlur={formik.handleBlur}
              required={true}
              error={formik.touched.first_name && formik.errors.first_name}
            />
            <InputField
              label="Last Name"
              name="last_name"
              type="text"
              placeholder="Last name"
              onChange={formik.handleChange}
              value={formik.values.last_name}
              onBlur={formik.handleBlur}
              error={formik.touched.last_name && formik.errors.last_name}
            />
            <InputField
              label="Address1"
              name="address1"
              type="text"
              placeholder="Address1"
              onChange={formik.handleChange}
              value={formik.values.address1}
              onBlur={formik.handleBlur}
              error={formik.touched.address1 && formik.errors.address1}
            />
            <InputField
              label="Address2"
              name="address2"
              type="text"
              placeholder="Address2"
              onChange={formik.handleChange}
              value={formik.values.address2}
              onBlur={formik.handleBlur}
              error={formik.touched.address2 && formik.errors.address2}
            />
            <InputField
              label="Ladnmark"
              name="landmark"
              type="text"
              placeholder="Landmark"
              onChange={formik.handleChange}
              value={formik.values.landmark}
              onBlur={formik.handleBlur}
              error={formik.touched.landmark && formik.errors.landmark}
            />
            <InputField
              label="Postcode"
              name="postcode"
              type="text"
              placeholder="Postcode"
              onChange={formik.handleChange}
              value={formik.values.postcode}
              onBlur={formik.handleBlur}
              error={formik.touched.postcode && formik.errors.postcode}
            />
            <div className="mb-4">
              <label className="mb-1 block">Country</label>
              <select
                className="w-full border p-2"
                value={selectedCountry}
                onChange={(e) => {
                  setSelectedCountry(e.target.value)
                  formik.setFieldValue('country', e.target.value)
                  formik.setFieldValue('state', '')
                  formik.setFieldValue('city', '')
                }}
              >
                <option value="">Select Country</option>
                {countries.map((country: any) => (
                  <option key={uuid()} value={country.isoCode}>
                    {country.name}
                  </option>
                ))}
              </select>
            </div>

            {/* State */}
            {states.length > 0 && (
              <div className="mb-4">
                <label className="mb-1 block">State</label>
                <select
                  className="w-full border p-2"
                  value={selectedState}
                  onChange={(e) => {
                    setSelectedState(e.target.value)
                    formik.setFieldValue('state', e.target.value)
                    formik.setFieldValue('city', '')
                  }}
                >
                  <option value="">Select State</option>
                  {states.map((state: any) => (
                    <option key={uuid()} value={state.isoCode}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* City */}
            {cities.length > 0 && (
              <div className="mb-4">
                <label className="mb-1 block">City</label>
                <select
                  className="w-full border p-2"
                  value={selectedCity}
                  onChange={(e) => {
                    setSelectedCity(e.target.value)
                    formik.setFieldValue('city', e.target.value)
                  }}
                >
                  <option value="">Select City</option>
                  {cities.map((city: any) => (
                    <option key={uuid()} value={city.name}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="mb-5">
              <label className="mb-2 flex text-sm leading-none font-medium text-gray-700">
                Role
              </label>
              <div className="flex gap-6">
                <label className="flex items-center gap-2 text-sm text-gray-700">
                  <input
                    type="radio"
                    name="status"
                    value="active"
                    checked={formik.values.status === 'active'}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    required
                  />
                  Active
                </label>

                <label className="flex items-center gap-2 text-sm text-gray-700">
                  <input
                    type="radio"
                    name="status"
                    value="inactive"
                    checked={formik.values.status === 'inactive'}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    required
                  />
                  Inactive
                </label>
              </div>

              <div className="flex gap-6">
                <label className="mb-2 flex text-sm leading-none font-medium text-gray-700">
                  Status
                </label>
              </div>
              <div className="flex gap-6">
                <label className="mb-2 flex text-sm leading-none font-medium text-gray-700"></label>
                <label className="flex items-center gap-2 text-sm text-gray-700">
                  <input
                    type="radio"
                    name="role"
                    value="admin"
                    checked={formik.values.role === 'admin'}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  Admin
                </label>

                <label className="flex items-center gap-2 text-sm text-gray-700">
                  <input
                    type="radio"
                    name="role"
                    value="inventory_manager"
                    checked={formik.values.role === 'inventory_manager'}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  Inventory Manager
                </label>
                <label className="flex items-center gap-2 text-sm text-gray-700">
                  <input
                    type="radio"
                    name="role"
                    value="customer_support"
                    checked={formik.values.role === 'customer_support'}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  Customer Support
                </label>
                <label className="flex items-center gap-2 text-sm text-gray-700">
                  <input
                    type="radio"
                    name="role"
                    value="logistics_manager"
                    checked={formik.values.role === 'logistics_manager'}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  Logistics Manager
                </label>
              </div>

              <div className="flex gap-6">
                <label className="mb-2 flex text-sm leading-none font-medium text-gray-700">
                  Gender
                </label>
              </div>
              <div className="flex gap-6">
                <label className="mb-2 flex text-sm leading-none font-medium text-gray-700"></label>
                <label className="flex items-center gap-2 text-sm text-gray-700">
                  <input
                    type="radio"
                    name="gender"
                    value="male"
                    checked={formik.values.gender === 'male'}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    required
                  />
                  Male
                </label>

                <label className="flex items-center gap-2 text-sm text-gray-700">
                  <input
                    type="radio"
                    name="gender"
                    value="female"
                    checked={formik.values.gender === 'female'}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    required
                  />
                  Female
                </label>
              </div>
              <div className="mt-3">
                <Button
                  label="Add"
                  type="submit"
                  className="rounded-lg bg-purple-900 py-2 text-center text-sm text-white transition hover:bg-purple-950"
                  loading={loading}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default EditCustomerModal
